import { db } from "./firebase";
import { useState } from "react";
import {
  getAuth,
  sendPasswordResetEmail,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [resetStatus, setResetStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      // Admin login
      const adminQuery = query(
        collection(db, "admins"),
        where("email", "==", email)
      );
      const adminSnapshot = await getDocs(adminQuery);

      console.log("Admin snapshot found?", !adminSnapshot.empty);

      if (!adminSnapshot.empty) {
        const adminDoc = adminSnapshot.docs[0].data();
        console.log("Admin doc:", adminDoc);
        if (adminDoc.password === password) {
          localStorage.setItem("isAdmin", "true");
          navigate("/admin-dashboard");
          return;
        } else {
          console.log("Password mismatch:", adminDoc.password, "!=", password);
        }
      }

      // Officer login
      const officerRef = doc(db, "officers", email);
      const officerSnap = await getDoc(officerRef);

      if (officerSnap.exists()) {
        localStorage.setItem("isOfficer", "true");
        localStorage.setItem("officerEmail", email);
        navigate("/en/officer-dashboard");
        return;
      }

      setMessage("❌ Invalid credentials.");
    } catch (error) {
      console.error("Login error:", error);
      setMessage("❌ Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setResetStatus("");
    if (!email) {
      setResetStatus("Please enter your email above.");
      return;
    }
    try {
      // Check if the email is registered in Firebase Auth
      const auth = getAuth();
      const emailLower = email.trim().toLowerCase();
      const methods = await fetchSignInMethodsForEmail(auth, email);
      if (methods.length === 0) {
        setResetStatus(
          "This account is not eligible for password reset. Please contact your administrator."
        );
        return;
      }
      await sendPasswordResetEmail(auth, email);
      setResetStatus(
        "A password reset email was sent. Check your spam folder if you don't see it."
      );
    } catch (error) {
      setResetStatus("Error sending reset email: " + (error.message || ""));
    }
  };

  return (
    <main
      style={{
        padding: "2rem",
        fontFamily: "sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "2rem",
          maxWidth: "400px",
          margin: "2rem auto",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "1.5rem",
            gap: "1.1rem",
            marginLeft: "0px",
          }}
        >
          <img
            src="assets/HMBHOUSE.png"
            alt="Home"
            onClick={() => navigate("/")}
            style={{
              width: "90px",
              height: "90px",
              marginBottom: "0.5rem",
              cursor: "pointer",
              flexShrink: 0,
              marginRight: "0.8rem",
            }}
          />
          <h1
            style={{
              color: "#0098BA",
              fontSize: "1.75rem",
              margin: 0,
              textAlign: "center",
            }}
          >
            Admin Login
          </h1>
        </div>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: "#0098BA",
              color: "white",
              padding: "0.75rem",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <button
          onClick={handleForgotPassword}
          style={{
            marginTop: "1rem",
            backgroundColor: "#0098BA",
            color: "white",
            padding: "0.75rem",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "100%",
          }}
        >
          Forgot Password
        </button>

        {resetStatus && (
          <p style={{ marginTop: "1rem", color: "#333" }}>{resetStatus}</p>
        )}
        {message && (
          <p style={{ color: "red", marginTop: "1rem" }}>{message}</p>
        )}
      </div>
    </main>
  );
}
